(() => {
  const init = root => {
    const link = root.querySelector('[data-guide-back]');
    if (!link) return;
    const candidates = [new URL(location.href).searchParams.get('return_to'), document.referrer];
    for (const value of candidates) {
      if (!value) continue;
      try {
        const url = new URL(value, location.origin);
        if (url.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[^/]+\/?$/i.test(url.pathname)) continue;
        const current = new URL(location.href);
        const theme = current.searchParams.get('preview_theme_id');
        if (theme) url.searchParams.set('preview_theme_id', theme);
        link.href = url.href;
        link.textContent = link.dataset.productLabel;
        break;
      } catch (_) {}
    }
  };
  document.querySelectorAll('[data-measurement-guide]').forEach(init);
  document.addEventListener('shopify:section:load', event => {
    const guide = event.target.querySelector('[data-measurement-guide]');
    if (guide) init(guide);
  });
})();
